import { render, staticRenderFns } from "./dialog_addPet.vue?vue&type=template&id=2af703da&scoped=true&"
import script from "./dialog_addPet.vue?vue&type=script&lang=js&"
export * from "./dialog_addPet.vue?vue&type=script&lang=js&"
import style0 from "./dialog_addPet.vue?vue&type=style&index=0&id=2af703da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af703da",
  null
  
)

export default component.exports